import React from 'react';
import { useLocation } from 'react-router-dom';
import config from '@plone/volto/registry';
import { Grid } from 'semantic-ui-react';
import { RenderBlocks } from '@plone/volto/components';
import { COLUMNSBLOCK } from '@eeacms/volto-columns-block/constants';
import cx from 'classnames';

import { getColumns } from '@eeacms/volto-columns-block/ColumnsBlock/utils';
import { getStyle } from '@eeacms/volto-columns-block/Styles';

const ColumnsBlockView = (props) => {
  const location = useLocation();
  const { gridSizes } = config.blocks.blocksConfig[COLUMNSBLOCK];
  const { data = {}, gridSize = 12, gridCols = [] } = props.data;
  const metadata = props.metadata || props.properties;
  const columnList = getColumns(data);

  const bg = props.data?.background_color || 'gray';

  const customId = props.data?.title
    ?.toLowerCase()
    ?.replace(/[^a-zA-Z-\s]/gi, '')
    ?.trim()
    ?.replace(/\s+/gi, '-');

  return (
    <section
      className={cx('columns-view', `columns--${bg}`)}
      id={customId}
      aria-label="Columns block"
    >
      <Grid
        columns={gridSize}
        className={cx('column-grid', {
          'reverse-wrap': props.data.reverseWrap,
        })}
      >
        {columnList.map(([id, column], index) => (
          <Grid.Column
            key={id}
            {...(gridSizes[gridCols[index]] || gridCols[index])}
            className={cx(
              'column-blocks-wrapper',
              column.settings?.column_class,
            )}
            {...getStyle(column.settings || {})}
          >
            <RenderBlocks
              {...props}
              location={location}
              metadata={metadata}
              content={column}
            />
          </Grid.Column>
        ))}
      </Grid>
    </section>
  );
};

export default ColumnsBlockView;
